import React, { useEffect, useState } from 'react'
import { FormGroup, FormText, Input } from 'reactstrap'

import { api } from '../../utils'

const LOCALIZATION_OPTIONS_ENDPOINT = 'llm-visibility-schedules/localization-options/'

const EMPTY_OPTIONS = { countries: [], languages: [] }

const LocalizationFields = ({
  country,
  setCountry,
  language,
  setLanguage,
  countryId = 'llm-visibility-country',
  languageId = 'llm-visibility-language',
}) => {
  const [options, setOptions] = useState(EMPTY_OPTIONS)
  const [loadError, setLoadError] = useState(false)

  useEffect(() => {
    let isMounted = true

    api
      .get(LOCALIZATION_OPTIONS_ENDPOINT)
      .then((response) => {
        if (!isMounted) return

        const data = response.data || {}
        setOptions({
          countries: Array.isArray(data.countries) ? data.countries : [],
          languages: Array.isArray(data.languages) ? data.languages : [],
        })
      })
      .catch(() => {
        if (isMounted) setLoadError(true)
      })

    return () => {
      isMounted = false
    }
  }, [])

  const disabled = loadError || !options.countries.length || !options.languages.length

  return (
    <>
      <FormGroup>
        <label htmlFor={countryId} className="form-control-label">
          Country
        </label>
        <Input
          className="form-control-alternative"
          type="select"
          id={countryId}
          value={country}
          onChange={(event) => setCountry(event.target.value)}
          disabled={disabled}
          required
        >
          <option value="">Seleziona una country</option>
          {options.countries.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
      </FormGroup>
      <FormGroup>
        <label htmlFor={languageId} className="form-control-label">
          Lingua di domande e risposte
        </label>
        <Input
          className="form-control-alternative"
          type="select"
          id={languageId}
          value={language}
          onChange={(event) => setLanguage(event.target.value)}
          disabled={disabled}
          required
        >
          <option value="">Seleziona una lingua</option>
          {options.languages.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        <FormText color="muted">
          Country e lingua sono indipendenti; sono supportate combinazioni miste come Belgio +
          olandese.
          {loadError ? ' Impossibile caricare il catalogo DataForSEO.' : ''}
        </FormText>
      </FormGroup>
    </>
  )
}

export default LocalizationFields
